<sh-text size='super-header' class="header">Frequently Asked Questions</sh-text>
<div class="divFaqs">
  <div *ngFor="let item of faqData" class="faq">
    <ng-container *ngIf="item.allowedGroups.indexOf(userGroup) != -1">
      <sh-accordion [label]="item.functionality" [expanded]="item.expanded">
        <sh-text class="text" size='header-1'>{{item.question}}</sh-text>
        <ng-container *ngFor="let i of item.answer">
          <sh-text class="text" size='body-1'>{{i}}</sh-text>
        </ng-container>
      </sh-accordion>
    </ng-container>
    <br>
  </div>
</div>